import * as React from 'react';
import { Theme } from '@mui/styles';
import  { withStyles } from '@mui/styles';

import {
	theme,
	styleRules,
	// logoFileName,
  } from "~common/components/app-view/theme";

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import {AppBar} from '@mui/material';
import {Toolbar} from '@mui/material';
import {Typography} from '@mui/material';
import {Button} from '@mui/material';
import {IconButton, Tooltip} from '@mui/material';

import { createTheme, adaptV4Theme } from '@mui/styles';
import { grey } from "@mui/material/colors";

import { StyledEngineProvider } from '@mui/material/styles';

import { ThemeProvider } from '@mui/material/styles';
import { StylesProvider } from '@mui/styles';


import MenuDrawer from '~common/components/app-view/menu-drawer';
import UserPrefsButton from '~common/components/app-view/user-prefs-button';
import FloatingTrigger from '~common/components/floating-trigger';
import {Hidden} from '@mui/material';
import {Avatar} from '@mui/material';
import {Chip} from '@mui/material';

import PortalUserContext from '~common/lib/portal-user-context';
// import helpDocumentButton from '../help-document-button';
// import { createMuiTheme } from '@mui/styles';

import ErrorBoundary from '~common/components/error-boundary'

import HomeButton from '~common/components/home'

var Mousetrap = require("mousetrap")

import MyReportCard from '~pcard/components/my-reports-card';
import MyTransactionsCard from '~pcard/components/my-transactions-card';
import AcknowledgeDocumentSwitch from '~common/components/acknowledge-document-switch'
import NewUserCard from "~auth/views/new-user-card-renderer";
import RemitVendorSuggestionRenderer from "~invoice-inquiry/components/remit-vendor-suggestion-renderer";
import PortalUserSuggestionRenderer from "~common/components/portal-user-suggestion-renderer";
import InviteOnboardingUserDialogue from "~invoice-processing/components/invite-onboarding-user-dialogue";


MyReportCard.register()
MyTransactionsCard.register()
AcknowledgeDocumentSwitch.register()
NewUserCard.register()
RemitVendorSuggestionRenderer.register()
PortalUserSuggestionRenderer.register()
InviteOnboardingUserDialogue.register()

Mousetrap.prototype.stopCallback = function(e, element) {
	e.preventDefault()
	return false
}

  export const newColor = '#1c3862';
  const primaryColor = "#763e0b"
  const raisedButtonPrimary =  "#763e0b"
  const secondaryColor = '#0B6623'
  const raisedButtonContained = "#6A9753" // Green
  const raisedButtonContainedDefault = "#bdbdbd"

  declare module "@mui/material/Button" {
	interface ButtonPropsColorOverrides {
	  default: true;
	}
  }
  
  declare module '@mui/styles' {
	interface DefaultTheme extends Theme {}
  }
  
  declare module "@mui/material" {
	interface Color {
	  main: string;
	  dark: string;
	}
  }

// const theme = createTheme(adaptV4Theme({
// 	props: {
// 		MuiTextField: {
// 		  variant: 'standard'
// 		},
// 		MuiFormControl: {
// 		  variant: 'standard'
// 		},
// 		MuiFormSelect: {
// 		  variant: 'standard'
// 		},
// 	},
//     palette: {
//         type: "light",
//         primary: {
// 			main: primaryColor,
//         },
//         secondary: {
//             main:secondaryColor,
//         },
// 		default: {
// 			main: grey[300],
// 			dark: grey[400]
// 		}
//     },
//     overrides: {
// 		MuiAppBar: { // Name of the component ⚛️ / style sheet
// 		  root: { // Name of the rule
// 			background: 'linear-gradient(0deg, #e5e500 0%, #ffeb00 100%)',
//           },
// 		},
// 		MuiButton: {
// 			outlined: {
// 				borderColor: "#ff8000",
// 				backgroundColor: "#fff",
// 				color: "black"
// 			},
// 			outlinedPrimary: {
// 				borderColor: "#ff8000",
// 				backgroundColor: "#fff",
// 				color: "black"
// 			},
// 			outlinedSecondary: {
// 				borderColor: "#ff8000",
// 				backgroundColor: "#fff",
// 				color: "black"
// 			},
// 			containedPrimary: {
// 				backgroundColor: raisedButtonPrimary,
// 				color: "#fff"
// 			},
// 			contained: {
// 				backgroundColor: raisedButtonContainedDefault,
// 				color: '#1f1f1f'
// 			},
// 			containedSecondary: {
// 				backgroundColor: raisedButtonContained,
// 				color: "#fff"
// 			}
// 		},
// 		MuiBadge: {
// 			colorPrimary: {
// 				backgroundColor: raisedButtonPrimary
// 			}
// 		},
//         MuiFormLabel:{
//             asterisk: {
//                 color: 'red',
//                 fontWeight:600
//             },
//             root: {
//                 color: primaryColor 
//             }
//         },
//         MuiTypography: {
//             h5: {
//                 fontSize: "1.75rem",
//                 fontWeight: 500,
//                 lineHeight: "1.20588em",
//                 marginBottom: 15
//             },
//             subtitle1: {
//                     color: primaryColor
//             }
// 		},
// 		MuiListSubheader:{
// 			sticky: {
// 				backgroundColor: '#fff'
// 			}
// 		}
//     }
//   }));

const styles = (theme: Theme): StyleRules => styleRules;
// const styles = (theme: Theme): StyleRules => ({
// 	root: {
// 		textAlign: 'unset',
// 		paddingTop: 75,
// 		paddingLeft: 15,
//         paddingRight: 15,
//         //background: "black url(https://static.boydgaming.net/boydgaming/assets/shell/background.jpg) top no-repeat;",

// 	},
// 	toolbar: {
// 		'@media only print': {display: 'none'}	
// 	},
// 	flex: {
// 		flex: 1
// 	},
// 	appTitle: {
// 		flex: 1,
// 		color: '#bdbdbd',
// 		marginTop: 5,
// 		fontFamily: "Arial,san-serif,Helvetica,Trebuchet MS"
// 	},
// 	drawerList: {
// 		width: 250
// 	},
// 	menuButton: {
// 		color: "#626262",
// 		marginLeft: -12,
// 		marginRight: 20,
// 	},
// 	logo: {
//         marginTop: 0,
// 		height: 40,
// 		width: 'auto'
// 	},
// 	bottomPadding: {
// 		height: 60
// 	},
// 	// chip: {
// 	// 	margin: theme.spacing.unit
// 	// },
// 	homeIcon: {
// 		marginRight: 10
// 	}
// });

interface Props extends React.HTMLProps<HTMLDivElement> {
	hideToolbar?: boolean;
	history: any;
	areaKey?: string;
	helpDocUrl?: string;
  isTokenUser?: boolean;
}

type State = {
	drawerOpen: boolean;
	anchorEl?: HTMLElement;
	helpDocUrl?: string | undefined;
};

class AppView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props);
		this.handleLogin = this.handleLogin.bind(this);
	}

	state = {
		anchorEl: undefined,
		drawerOpen: false,
		helpDocUrl: this.props.helpDocUrl
	};

	componentDidMount() {
		Mousetrap.bind("ctrl+alt+h", ()=>{
			window.location.href = "/"
		})
	}

	handleLogin = (event: any) => {
		const path = '/login';
		this.props.history.push(path);
	};

	handleDrawerMenu = (event: any) => {
		this.setState({ drawerOpen: true });
	};

	handleDrawerMenuClose = () => {
		this.setState({ drawerOpen: false });
	};

	render() {
		console.log("loves app view")
		const { history, areaKey, isTokenUser } = this.props;
		const { classes }: { classes: ClassNameMap } = this.props;
		const { drawerOpen, helpDocUrl } = this.state;

		const isLoggedIn = PortalUserContext.isLoggedIn();
		const showLoginButton = !isLoggedIn && window.location.pathname != '/login';

		let floatingHelpTrigger ;
		if (helpDocUrl) {
			floatingHelpTrigger = <FloatingTrigger faIconClass="fas fa-life-ring" url={helpDocUrl} />;
		}

		let floatingSuggestionTrigger ;
		if (areaKey) {
			let right = 15;
			if (floatingHelpTrigger != null) {
				right = 90;
			}
			floatingSuggestionTrigger = (
				<FloatingTrigger faIconClass="fas fa-lightbulb" url={'/suggestions' + '/' + areaKey} right={right} />
			);
		}

		let bottomPadding ;
		if (floatingHelpTrigger || floatingSuggestionTrigger) {
			bottomPadding = <div className={classes.bottomPadding} />;
		}

		let sizer ;
		if (window.location.hostname === 'localhost') {
			sizer = (
                <span>
				<Hidden only={["sm", "md", "lg", "xl"]}>
					<Chip avatar={<Avatar>XS</Avatar>} label="Extra Small" className={classes.chip} />
				</Hidden>
				<Hidden only={["xs", "md", "lg", "xl"]}>
					<Chip avatar={<Avatar>SM</Avatar>} label="Small" className={classes.chip} />
				</Hidden>
				<Hidden only={["xs", "sm", "lg", "xl"]}>
					<Chip avatar={<Avatar>MD</Avatar>} label="Medium" className={classes.chip} />
				</Hidden>
				<Hidden only={["xs", "sm", "md", "xl"]}>
					<Chip avatar={<Avatar>LG</Avatar>} label="Large " className={classes.chip} />
				</Hidden>
				<Hidden only={["xs", "sm", "md", "lg"]}>
					<Chip avatar={<Avatar>XL</Avatar>} label="Extra Large" className={classes.chip} />
				</Hidden>
                </span>
			);
		}

		return (
			<ErrorBoundary>
				<StyledEngineProvider injectFirst>
					<ThemeProvider theme={theme}>
						{/* <StylesProvider injectFirst> */}
						<div className={classes.root}>
							<MenuDrawer open={drawerOpen} onClose={this.handleDrawerMenuClose} history={history} />
							<AppBar position="fixed">
								<Toolbar className={classes.toolbar}>
									{isLoggedIn && !isTokenUser && (
										<IconButton
											onClick={this.handleDrawerMenu}
											className={classes.menuButton + "  menu-toggle "}
											aria-label="Menu"
										>
										<i className="fas fa-bars"></i>
										</IconButton>
									)}
									<img className={classes.logo} src="/static/assets/loves.png" />
									<Typography variant="h6" className={classes.appTitle}>
										{
											'' // TODO: jdouglas - Add functionality for portal setting on logo and title
										}
									</Typography>
									{sizer}
									{showLoginButton && <Button style={{color: "rgba(0, 0, 0, 0.87)"}} color="inherit" onClick={this.handleLogin}>Login</Button>}
									{isLoggedIn && 
										<label style={{color: '#6C6801', marginTop: 5, marginRight: 5, fontFamily: "Arial,san-serif,Helvetica,Trebuchet MS"}}>Welcome: {(window as any).App.userContext.displayName}</label>
									}
									{isLoggedIn && !isTokenUser && 
										<Tooltip enterDelay={500} title="Ctrl+Alt+H">
											<span className={classes.homeIcon}><HomeButton classes={{menuButton:classes.home}}/></span>
										</Tooltip>
									}
									{isLoggedIn && !isTokenUser && (
										<div>
											<UserPrefsButton classes={classes} color="inherit"  history={history} />
										</div>
									)}
								</Toolbar>
							</AppBar>
							{this.props.children}
							{floatingHelpTrigger}
							{/* {floatingSuggestionTrigger} */}
							{bottomPadding}
						</div>
						{/* </StylesProvider> */}
					</ThemeProvider>
				</StyledEngineProvider>
			</ErrorBoundary>
            
		);
	}
}

export default withStyles(styles)<any>(AppView);
